import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

export default function BriefInformation() {
    const { ref, inView } = useInView({
        triggerOnce: true,  
        threshold: 0.5,     
    });

    return (
        <div className="bg-[#D9D9D9]">
            <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
                <div className="flex justify-center sm:flex-row text-sm mt-5">
                    <div className="flex space-x-5 mb-4 sm:mb-0 whitespace-nowrap justify-center">
                        <h1 className="text-2xl font-poppinsBold text-bprDarkBlue">BPR PALU ANUGERAH</h1>
                    </div>
                </div>
                <div className="mt-7 font-poppinsRegular">
                    <p className="text-textPrimary text-center">
                        Merupakan perusahaan yang bergerak di Bidang Perbankan utamanya sektor UMKM dengan fungsi menerima dana dari masyarakat berupa tabungan dan deposito serta menyalurkan kembali ke masyarakat berupa pinjaman atau kredit.
                    </p>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-16 gap-y-5">
                    <div className="flex flex-col justify-center items-center" ref={ref}>
                        <motion.span
                            className="font-poppinsBold text-red-800 text-3xl"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                        >
                            {inView && <CountUp end={4} duration={1} />}
                        </motion.span>
                        <span className="text-bprDarkBlue text-xl font-poppinsBold text-center">Kantor Cabang</span>
                    </div>
                    <div className="flex flex-col justify-center items-center" ref={ref}>
                        <motion.span
                            className="font-poppinsBold text-red-800 text-3xl"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                        >
                            {inView && <CountUp end={1000} duration={1} suffix='+'/>}
                        </motion.span>
                        <span className="text-bprDarkBlue text-xl font-poppinsBold">Nasabah</span>
                    </div>
                    <div className="flex flex-col justify-center items-center" ref={ref}>
                        <motion.span
                            className="font-poppinsBold text-red-800 text-3xl"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                        >
                            {inView && <CountUp end={100} duration={1} suffix='+'  /> }
                        </motion.span>
                        <span className="text-bprDarkBlue text-xl font-poppinsBold">Staff</span>
                    </div>
                    <div className="flex flex-col justify-center items-center" ref={ref}>
                        <motion.span
                            className="font-poppinsBold text-red-800 text-3xl"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                        >
                            {inView && <CountUp end={6} duration={1}   /> }
                        </motion.span>
                        <span className="text-bprDarkBlue text-xl font-poppinsBold">Produk</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
